import { G } from '@mobily/ts-belt';

type AllocationAmountRow = {
  amount?: number | null;
  matching_contribution_amount?: number | null;
};

const amountFields = ['amount', 'matching_contribution_amount'] as const;

export type NegativeAllocationAmount = {
  field: (typeof amountFields)[number];
  amount: number;
  line: number;
};

export function findNegativeAllocationAmount(
  rows: AllocationAmountRow[],
  dataStartingLine: number,
): NegativeAllocationAmount | null {
  for (const [index, row] of rows.entries()) {
    for (const field of amountFields) {
      const amount = row[field];
      if (G.isNotNullable(amount) && amount < 0) {
        return { field, amount, line: index + dataStartingLine };
      }
    }
  }

  return null;
}
